/**
 * App Config File
 **/
let config= undefined;
try {
    config = require('../config/config');
} catch (err) {

    config = {};
}
export default {
    appLogo: '/static/img/logo.png',
    appLogo2: '/static/img/logo2.png',
    copyrightText: '© 2005-2019 Aseguradora del sur. All Rights Reserved.', // Copyright Text    

    baseUrl:  process.env['VUE_APP_APS_URL']||(config.default?config.default.baseUrl:null), 
    BrokerKerygmaseg : process.env['VUE_APP_BROKE_KERYGMASEG'],   
    baseUrlIAM: (config.default?config.default.baseUrlIAM:null)||process.env['VUE_APP_IAM_URL'],    
    baseUrlFileServer:(config.default?config.default.baseUrlFileServer:null)||process.env['VUE_APP_FMS_URL'],    
    baseUrlChatbootSofia: 'https://sofia.aseguradoradelsur.com/sofi/client/chatSofi.js',
    GNS: {
        URL_BASE: (config.default?config.default.GNS_URL_BASE:null)||process.env['VUE_APP_GNS_URL'],    
        URL_PUSH: "/push",
        URL_SUBSCRIBE: "/subscribe",
        URL_CHANNEL: "/channel"
    },
    botonPagosBaseUrl:  (config.default?config.default.botonPagosBaseUrl:null)||process.env['VUE_APP_BOTON_PAGOS_URL'], 
    botonPagosAppCode:  (config.default?config.default.botonPagosAppCode:null)||process.env['VUE_APP_BOTON_PAGOS_APP_CODE'], 
    botonPagosAppUser:  (config.default?config.default.botonPagosAppUser:null)||process.env['VUE_APP_BOTON_PAGOS_APP_USER'], 
    botonPagosAppPass:  (config.default?config.default.botonPagosAppPass:null)||process.env['VUE_APP_BOTON_PAGOS_APP_PASS'], 
    seguridadBaseUrl:  (config.default?config.default.seguridadBaseUrl:null)||process.env['VUE_APP_ASURAPI_SEGURIDAD'], 
    siaerpBaseUrl:  (config.default?config.default.siaerpBaseUrl:null)||process.env['VUE_APP_ASURAPI_SIAERP'], 
    ecommerceBaseUrl:   (config.default?config.default.ecommerceBaseUrl:null)||process.env['VUE_APP_ECOMMERCE_URL'],

    aimAsurApiBaseUrl:  (config.default?config.default.siaerpBaseUrl:null)||process.env['VUE_APP_ASURAPI_AIM'], 
    
    aimAsurApiDigitalEasyUrl:  process.env['VUE_APP_ASURAPI_DIGITALEASY'], 
    aimAsurApiPeopleSoftUrl:  process.env['VUE_APP_ASURAPI_PEOPLE'], 
    
    
}
